import { render, staticRenderFns } from "./AssignRoutineDialog.vue?vue&type=template&id=220937d0&scoped=true"
import script from "./AssignRoutineDialog.vue?vue&type=script&lang=js"
export * from "./AssignRoutineDialog.vue?vue&type=script&lang=js"
import style0 from "./AssignRoutineDialog.vue?vue&type=style&index=0&id=220937d0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "220937d0",
  null
  
)

export default component.exports